import { FolderIcon, HStack, Text } from '@cdl/heartbeat-react';

type Props = {
  data: string;
};

export const CompletionColumn: React.FC<Props> = ({ data }) => {
  return (
    <HStack
      border='1px'
      borderRadius={5}
      borderColor='neutral.200'
      float='left'
      alignItems='center'
      p='s'
      fontWeight='regular'
    >
      <FolderIcon />
      <Text>{data}</Text>
    </HStack>
  );
};
